import React from "react";
import "./DoctorTestimonials.css";
import drArmando from "../assets/testimonialImages/drArmandoB.webp"
import draDaniela from "../assets/testimonialImages/draDanielaV.webp"

function DoctorTestimonial({ name, position, photo, quote }) {
  return (
    <div className="testimonial-card">
      <span className="testimonial-quote-symbol">“</span>
      <p className="testimonial-text">{quote}</p>
      <div className="testimonial-author">
        <img src={photo} alt={name} loading="lazy" height="56px" width="56px" className="testimonial-photo" />
        <div>
          <div className="testimonial-name">{name}</div>
          <div className="testimonial-position">{position}</div>
        </div>
      </div>
    </div>
  );
}

export default function DoctorTestimonials() {
  return (
    <div className="testimonials-container">
      <DoctorTestimonial
        name="Dr. Armando Bolaños"
        position="Médico Estético"
        photo={drArmando} 
        quote="Holistique es uno de nuestros aliados comerciales clave, reconocido por su compromiso con la calidad y la innovación en el área de la salud y el bienestar. Holistique nos provee productos confiables que nos permiten ofrecer a nuestros pacientes soluciones seguras, efectivas y de última generación."
      />
      <DoctorTestimonial
        name="Dra. Daniela Vargas"
        position="Cirujano Plastico"
        photo={draDaniela}
        quote="Holistique es una empresa preocupada por ofrecer equipos y tratamientos de alta calidad. Más que un distribuidor se ha convertido en un aliado comercial. Siempre atentos a brindar un servicio de primera y acompañamiento en nuestros procesos."
      />
    </div>
  );
}
